// ─── Pure helpers ─────────────────────────────────────────────────────────────

export function fmtDate(v: string | null): string {
  if (!v) return "—"
  const d = new Date(v)
  return d.toLocaleDateString("es-AR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  })
}

export function fmtDatetime(v: string | null): string | null {
  if (!v) return null
  const d = new Date(v)
  return d.toLocaleString("es-AR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  })
}

export function isoToLocal(v: string | null): string {
  if (!v) return ""
  try { return new Date(v).toISOString().slice(0, 16) } catch { return "" }
}

export const DETAIL_DATE_FIELDS = new Set([
  "expectedDate","loadingDate","unloadingDate","collectionScheduleDate",
  "collectionArrival","collectionDeparture","expectedArrivalBorder",
  "passwordAnticipation","borderArrival","authorizedCrossing","passwordRequest",
  "customsOriginEntry","customsOriginExit","customsTransitEntry","customsTransitExit",
  "expectedCustomsDestination","customsDestinationEntry","customsDestinationExit",
  "expectedUnloadingArrival","unloadingDeparture","unloadingArrival",
])

export function buildDetailPayload(form: Record<string, string>): Record<string, unknown> {
  const out: Record<string, unknown> = {}
  for (const [k, v] of Object.entries(form)) {
    if (k === "storageDays") { out[k] = v.trim() ? Number(v) : null }
    else if (DETAIL_DATE_FIELDS.has(k)) { out[k] = v.trim() ? new Date(v).toISOString() : null }
    else { out[k] = v.trim() || null }
  }
  return out
}
